// Lane B8's screens, registered the way every lane registers its own (lane contract C-29) and hosted in MissionShell's
// content slot, inside its one `.mc` island (none of them draws a McRoot); their V1 parts (the not-found screen, the
// offer read's refusal and loading boundary) render through the shell's V1 slot, outside the island (shell/island.tsx):
//
//   #requisitions/R-####/offer/<application>[?tab=reference|compensation|offer]
//                                 the Offer page (*Offer package — {candidate}*) behind `offer.open`, the offer's own
//                                 read (its refusal is §3.3's); above B2's requisition detail (specificity 2)
//
// The requisition-level `#requisitions/R-####/offer` tab (the offers and the disposition worklist) stays V1's screen
// (views/Offer.tsx OfferTab, hosted by the V1 requisition page). Any other route under the offer is the not-found
// screen, never a substitute record. App.tsx's former offer case leaves with the one import line in shell/views.ts.

import { createElement } from "react";
import { registerView, type ViewProps } from "@/shell/viewRegistry";
import { OfferPage } from "@/views/offer/OfferPage";
import { tabOf } from "@/views/offer/OfferPageView";

function OfferRoute({ route }: ViewProps) {
  const [rid = "", , aid = ""] = route.parts;
  return createElement(OfferPage, { key: `${rid}/${aid}`, rid, aid, tab: tabOf(route.raw) });
}

registerView(/^requisitions\/R-\d+\/offer\/[^/]+$/, OfferRoute, { lane: "B8", specificity: 2 });
